import { render } from "./createEditProvider.vue?vue&type=template&id=0ccfaacc"
import script from "./createEditProvider.vue?vue&type=script&lang=js"
export * from "./createEditProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__